import Select from "react-select";
import NoRecordFound from "../../../../../../components/ui/noRecordFound/NoRecordFound";

/**
 * type: "TVOC" | "GWP_GENERAL" | "GWP_CONCRETE" | "COMMON"
 *
 * Common columns (all certificates):  Cert Number | Item Code | Tick Rating | ...extra columns...
 * Only the "extra columns" differ per certificate.
 * Each extra column: { header, render(row, { onFileDownload }) }
 */
const ReadOnlyInput = ({ value }) => (
  <div className="input-group">
    <input type="text" className="form-control" value={value ?? ""} disabled />
  </div>
);

// GWP concrete
const uploadButtonStyle = {
  backgroundColor: "#2e8b00",
  borderColor: "#2e8b00",
  color: "#fff",
  padding: "6px 16px",
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: "600",
  border: "none",
  cursor: "not-allowed",
  opacity: 0.6,
};

const fileNameStyle = {
  color: "#2e8b00",
  fontWeight: "600",
  fontSize: "14px",
  textDecoration: "underline",
  maxWidth: "150px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  display: "inline-block",
  verticalAlign: "middle",
  cursor: "pointer",
};

const EXTRA_COLUMNS = {
  TVOC: [
    { header: "TVOC Emission", render: (row) => <ReadOnlyInput value={row.tvocEmission} /> },
    { header: "Formaldehyde Emission", render: (row) => <ReadOnlyInput value={row.formaldehydeEmission} /> },
  ],

  GWP_GENERAL: [
    { header: "Declared GWP (A1-A3)", render: (row) => <ReadOnlyInput value={row.declared} /> },
  ],

  GWP_CONCRETE: [
    {
      header: "Actions",
      render: (row, { onFileDownload }) => (
        <div className="form-group">
          <div className="file-upload-wrapper d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-success success-btn d-flex align-items-center justify-content-center"
              style={uploadButtonStyle}
              disabled
            >
              Upload
            </button>
            {row.certificateFileName && (
              <div className="d-flex align-items-center gap-1 ms-2" style={{ minWidth: 0 }}>
                <span
                  role="button"
                  tabIndex={0}
                  title={row.certificateFileName}
                  onClick={() => onFileDownload?.(row)}
                  onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onFileDownload?.(row)}
                  style={fileNameStyle}
                >
                  {row.certificateFileName}
                </span>
              </div>
            )}
          </div>
        </div>
      ),
    },
  ],

  COMMON: [],
};

const ReadOnlySelect = ({ value, options }) => (
  <div className="form-group">
    <Select
      className="custom-checkbox-select"
      value={value}
      options={options}
      placeholder="Select"
      isDisabled
    />
  </div>
);

const CostAllocation = ({
  type,
  rows = [],
  itemCodeOptions = [],
  tickOptions = [],
  onFileDownload, // only used by GWP_CONCRETE
}) => {
  const extraColumns = EXTRA_COLUMNS[type] ?? [];
  const totalColumns = 3 + extraColumns.length;

  return (
    <div className="cost-allocation-list member-list">
      <div className="content-section">
        <div className="table-section">
          <table>
            <thead>
              <tr>
                <th>Cert Number</th>
                <th>Item Code</th>
                <th>Tick Rating</th>
                {extraColumns.map((col) => (
                  <th key={col.header}>{col.header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.label}>
                  <td>{row.label} <span className="text-danger">*</span></td>
                  <td><ReadOnlySelect value={row.value} options={itemCodeOptions} /></td>
                  <td><ReadOnlySelect value={row.tickValue} options={tickOptions} /></td>
                  {extraColumns.map((col) => (
                    <td key={col.header}>{col.render(row, { onFileDownload })}</td>
                  ))}
                </tr>
              ))}

              {rows.length === 0 && (
                <tr>
                  <td colSpan={totalColumns}><NoRecordFound /></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CostAllocation;